import { InputAdornment } from '@mui/material';
import React from 'react';

import { InputKit } from 'components/kit/Input';

const InputField = (props) => {
	const { field, form, placeholder, normalize, textarea, ...rest } = props;

	const filedError = form?.errors ? form?.errors?.[field.name] : '';
	const filedTouched = form?.touched ? form?.touched?.[field.name] : false;

	return (
		<InputKit
			InputProps={{
				...rest.InputProps,
				'aria-label': 'weight',
				endAdornment: <InputAdornment position="end">{rest.InputProps?.endAdornment}</InputAdornment>,
				...rest.endAdornment,
			}}
			{...rest}
			{...field}
			error={rest?.error || !!(filedError && filedTouched)}
			helperText={filedTouched && filedError}
			name={rest?.name || field?.name}
			value={rest?.value || field?.value}
			multiline={textarea}
			rows={textarea ? 4 : undefined}
			placeholder={placeholder}
			type={rest.type}
			onChange={(e) => {
				if (normalize) {
					form.setFieldValue(field?.name, normalize(e.target.value), true);
					return;
				}
				rest?.onChange?.(e);
				field?.onChange(e);
			}}
		/>
	);
};

export default InputField;

InputField.defaultProps = {
	required: false,
	textarea: false,
	placeholder: '',
	name: '',
	value: '',
};

InputField.displayName = 'InputField input';
